import type { ReactNode } from 'react'
import { ClerkProvider } from '@clerk/clerk-react'
import { ptBR, enUS, esMX } from '@clerk/localizations'
import { useTranslation } from 'react-i18next'

/** Textos do Clerk (login, "Minha conta") para o idioma atual da tela. */
export function clerkLocalizationFor(language: string | undefined) {
  const base = (language ?? '').toLowerCase()
  if (base.startsWith('pt')) return ptBR
  if (base.startsWith('es')) return esMX
  return enUS
}

interface Props {
  publishableKey: string
  children: ReactNode
}

/**
 * FU-188-CONTA — a localização do Clerk seguia o idioma do carregamento da página
 * e nunca mais mudava: PT -> ES -> PT deixava "Minha conta" em espanhol. Agora ela
 * deriva do idioma vivo do i18n, e o ClerkProvider recebe um novo `localization`
 * a cada troca.
 */
export function LocalizedClerkProvider({ publishableKey, children }: Props) {
  const { i18n } = useTranslation()
  return (
    <ClerkProvider
      publishableKey={publishableKey}
      localization={clerkLocalizationFor(i18n.language)}
      telemetry={{ disabled: true }}
    >
      {children}
    </ClerkProvider>
  )
}
